import { AxiosResponse } from 'axios';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getKnowledgePortal } from 'services/claimsService';
import { ApplicationState } from 'store/store.inteface';
import { ApiResponse } from 'types/ApiResponse';
import { SagasAction } from 'types/SagasAction';
import { GetKnowledgePortals, KnowledgePortals, PORTAL_TYPES } from './types';
import { setKnowledgePortalAction, setError } from './actions';

export function* setKnowledgePortalSaga({
  payload,
}: SagasAction<GetKnowledgePortals>) {
  yield put(setError(null));
  try {
    const { cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<KnowledgePortals>> = yield call(
      getKnowledgePortal,
      cpId,
      payload,
    );
    yield put(setKnowledgePortalAction(data));
  } catch (error) {
    if (error.response && error.response.status === 404) {
      yield put(setError(error.response.data.reason));
    } else {
      console.log(error);
    }
  }
}

export default all([
  takeLatest(PORTAL_TYPES.GET_KNOWLEDGE_PORTAL_REQUEST, setKnowledgePortalSaga),
]);
